import { observer } from 'mobx-react-lite';

import { PopoverMenu } from '@gem/ui-kit';

import usePresenter from './presenter';

const Menu = ({ parent, reference }) => {
  const presenter = usePresenter({ parent });

  return (
    <PopoverMenu
      isOpened={true}
      placement="top-start"
      menuItems={presenter.menuItems}
      reference={reference.current}
      onClose={parent.onCloseMenu}
    />
  );
};

export default observer(Menu);
